import React, { useRef, useState } from 'react';
import toast from 'react-hot-toast';

import AuthService from '../services/auth.service';
import CheckButton from 'react-validation/build/button';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const required = (value) => {
  if (!value) {
    return (
      <div className='alert alert-danger' role='alert'>
        This field is required!
      </div>
    );
  }
};

const Login = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();

  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        () => {
          navigate('/profile');
          window.location.reload();
        },
        (error) => {
          const resMessage = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();

          setLoading(false);
          toast.error(resMessage);
        },
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className='container col-md-12 mt-5'>
      <div className='card card-container p-5 col-md-6 mx-auto'>
        <h3 className='text-center'>{t('nav.login')}</h3>
        <Form onSubmit={handleLogin} ref={form}>
          <div className='form-group mt-3'>
            <label htmlFor='username'>{t('auth.username')}</label>
            <Input type='text' className='form-control' name='username' value={username} onChange={onChangeUsername} validations={[required]} />
          </div>

          <div className='form-group mt-3'>
            <label htmlFor='password'>{t('auth.password')}</label>
            <Input type='password' className='form-control' name='password' value={password} onChange={onChangePassword} validations={[required]} />
          </div>

          <div className='form-group mt-3'>
            <button className='btn btn-primary btn-block' disabled={loading}>
              {loading && <span className='spinner-border spinner-border-sm'></span>}
              <span>{t('nav.login')}</span>
            </button>
          </div>

          <CheckButton style={{ display: 'none' }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  );
};

export default Login;
